<script setup>
  import { Link, usePage } from '@inertiajs/vue3';
  import DarkSwitch from '../DarkSwitch.vue';
  import OverlayBadge from 'primevue/overlaybadge';
  import { defineProps, ref } from 'vue';
  import { menuItems } from '@/constants/menuItems';

  const props = defineProps({
    user: Object,
    menuItems: {
      type: Array,
      required: false
    }
  });

  // Get the current URL from usePage
  const page = usePage();

  const unreadMessagesCount = ref(0);

  const getunreadmessages = async () => {
    return false;
    axios
      .get('/api/messenger/unread-threads-count')
      .then(response => {
        unreadMessagesCount.value = response.data.unread_threads_count;
        console.log('Unread messages count:', unreadMessagesCount);
      })
      .catch(error => {
        console.error('Error fetching unread messages count:', error);
      });
    setTimeout(getunreadmessages, 100000);
  };
</script>

<template>
  <div class="flex flex-col justify-center mt-[40px]">
    <div class="mx-auto flex flex-col">
      <div
        v-for="(item, index) in menuItems"
        :key="index"
        class="mx-6 my-4 flex items-center gap-3 dark:!text-gray-50 lg:ml-12"
      >
        <template v-if="item.text === 'Messages' && unreadMessagesCount > 0">
          <Link
            :href="item.routeName ? route(item.routeName) : item.href"
            :class="[
              'flex items-center gap-3 text-sm font-semibold tracking-wide text-black transition-colors duration-300 hover:text-primary hover:underline dark:!text-purple-300'
            ]"
          >
            <div class="flex h-6 w-6 items-center justify-center">
              <OverlayBadge
                :value="unreadMessagesCount"
                severity="danger"
                size="small"
              >
                <i :class="item.icon"></i>
              </OverlayBadge>
            </div>
            {{ item.text }}
          </Link>
        </template>
        <template v-else>
          <Link
            :href="item.routeName ? route(item.routeName) : item.href"
            :class="[
              'flex items-center gap-3 text-sm font-semibold tracking-wide text-black transition-colors duration-300 hover:text-primary hover:underline dark:!text-purple-300'
            ]"
          >
            <!-- Fixed size container for the icon -->
            <div class="flex h-6 w-6 items-center justify-center">
              <i :class="item.icon"></i>
            </div>
            {{ item.text }}
          </Link>
        </template>
      </div>

      <!-- Logout Button -->
      <div class="mx-6 my-4 flex items-center gap-3 lg:ml-12">
        <Link
          href="/logout"
          method="post"
          as="button"
          class="flex items-center gap-3 text-sm font-semibold tracking-wide text-primary hover:text-primary hover:underline dark:!text-purple-300"
        >
          <div class="flex h-6 w-6 items-center justify-center">
            <i class="fas fa-sign-out-alt"></i>
          </div>
          Logout
        </Link>
      </div>

      <DarkSwitch class="mx-6 my-4 lg:ml-12" />
    </div>
  </div>
</template>

<style scoped></style>
